import { Routes } from "@angular/router";
import { appAuthGuard } from "../_shared/guards/app-auth.guard";
import { DashboardDriverMapComponent } from "./dashboard/components/dashboard-driver-map/dashboard-driver-map.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DriverManagementComponent } from "./driver-management.component";
import { DriverManagerSettingsComponent } from "./driver-manager/components/driver-manager-settings/driver-manager-settings.component";
import { DriverManagerComponent } from "./driver-manager/driver-manager.component";
import { DriverOverviewComponent } from "./dashboard/components/driver-overview/driver-overview.component";
import { OvertimeManagementComponent } from "./overtime-management/overtime-management.component";
import { OverviewComponent } from "./overview/overview.component";
import { DriverInformationComponent } from "./driver-information/driver-information.component";
import { myDriversGuard } from "../_shared/guards/beta-user.guard";
import { ExecutiveStatsComponent } from "./executive-stats/executive-stats.component";
import { DriverVehicleAssignmentComponent } from "./driver-vehicle-assignment/driver-vehicle-assignment.component";
import { DriverVehicleAssignmentListComponent } from "./driver-vehicle-assignment/components/driver-vehicle-assignment-list/driver-vehicle-assignment-list.component";
import { DriverDocumentsComponent } from "./driver-documents/driver-documents.component";

export const driverManagementRoutes: Routes = [
  {
    path: 'driver-management',
    component: DriverManagementComponent,
    canActivate: [appAuthGuard, myDriversGuard],
    children: [
      { path: 'overview', component: OverviewComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'dashboard/driver-overview', component: DriverOverviewComponent },
      { path: 'driver-manager', component: DriverManagerComponent },
      { path: 'driver-manager/settings', component: DriverManagerSettingsComponent },
      { path: 'dashboard/dashboard-driver-map', component: DashboardDriverMapComponent },
      { path: 'overtime-management', component: OvertimeManagementComponent },
      { path: 'executive-stats', component: ExecutiveStatsComponent },
      { path: 'driver-information', component: DriverInformationComponent },
      { path: 'driver-documents', component: DriverDocumentsComponent },
      { path: 'driver-documents/:id', component: DriverDocumentsComponent },
      { path: 'driver-vehicle-assignment', component: DriverVehicleAssignmentComponent },
      { path: 'driver-vehicle-assignment-list', component: DriverVehicleAssignmentListComponent },
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
    ],
  },
]